/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetBrandCollectionRequest} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'
import {GetBrandCollectionResponse} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'


export const getBrandCollection = (request: GetBrandCollectionRequest, options?: CashRequestOptions) => post<GetBrandCollectionRequest, GetBrandCollectionResponse>("/2.0/cash/get-brand-collection", request, {...options, rejectOnError: true })